import Cookie from 'universal-cookie';
import { DOMAIN_NAME } from '../../components/constants';

/**
 * Gets all available cookies per environment.
 * Cookies source can be explicit passed via cookies object or by default with document cookie object.
 * @param {Object} [headerCookies] The current request header cookies (relevant for SSR only). Defaults to "document.cookies" in the client, and an empty string in the server.
 * @return {Object}
 */
const getAll = (headerCookies) => {
    const cookieSource = typeof document === 'undefined'
        ? headerCookies
        : document.cookie;

    if (!cookieSource) {
        return {};
    }

    return new Cookie(cookieSource).getAll();
};

/**
 * Sets a given cookie value over fiverr domain (relevant for CSR only) .
 * @param {String} name The cookie's name.
 * @param {any} value The cookie's value.
 * @param {Object|Number} options Cookie options, if a number is passed in it will be used to calculate "expires" option
 */
const set = (name, value, options = {}) => {
    if (typeof options === 'number') {
        // Passed "expires-in"
        options = {
            expires: new Date(
                Date.now() + options
            )
        };
    }

    options.domain = options.domain || DOMAIN_NAME;

    new Cookie()
        .set(name, value, options);
};

/**
 * Removes a given cookie name from document's cookies
 * @param {String} name The name of the cookie to be removed.
 */
const remove = (name) => new Cookie().remove(name);

export default {
    getAll,
    set,
    remove
};
